import Devextreme from "@sonphat/devextreme";
export default function Helper({ $Core, emitter, $store }) {
    Devextreme.$Core = $Core;
    this.isKhoaLuong = {};

    this.ThongBaoToast = (type, msg) => {
        let ParamsError = {
            isVisible: true,
            message: msg,
            type: type,
        };
        emitter.emit("onToast", ParamsError);
    };

    this.RequestPost = async ({
        keyRequest = "api",
        ServicesBE = "Make",
        url = "",
        dataPost = null,
        msgSuccess = null,
        msgError = null,
        msgCatch = null,
        msgCatchDetails = "Lỗi hệ thống client! \nNhấn tổ hợp phím Ctrl + Shift + R để thử lại!",
        typeNotificationSuccess = "Toast",
        typeNotificationError = "Popup",
    }) => {
        // Bắt buộc truyền thông báo
        if (!msgCatch || !msgError) {
            $Helper.ThongBaoToast(
                "error",
                "Chưa thể gửi request! Vui lòng kiểm tra lại!"
            );
        }
        if (this.isKhoaLuong[keyRequest]) return;
        $store.startLoading();
        this.isKhoaLuong[keyRequest] = "pending...";
        try {
            let rs = await $Core.Requests.Post({
                ServicesBE,
                url,
                dataPost,
            });

            if (
                (rs.hasOwnProperty("status") && rs.status) ||
                (rs.hasOwnProperty("State") && rs.State == "Success")
            ) {
                if (msgSuccess) {
                    if (typeNotificationSuccess == "Toast") {
                        $Helper.ThongBaoToast("success", msgSuccess);
                    } else if (typeNotificationSuccess == "Popup") {
                        $Helper.ThongBaoPopup({
                            type: "Success",
                            message_title: msgSuccess,
                        });
                    }
                }
            } else {
                if (typeNotificationError == "Popup") {
                    $Helper.ThongBaoPopup({
                        type: "Error",
                        message_title: msgError,
                        message: rs.message || rs.Message || "",
                    });
                } else if (typeNotificationError == "Toast") {
                    $Helper.ThongBaoToast(
                        "error",
                        msgError + " " + (rs.message || rs.Message || "")
                    );
                }
            }
            return rs;
        } catch (error) {
            console.log("🚀 ~ error:", error);
            if (typeNotificationError == "Popup") {
                $Helper.ThongBaoPopup({
                    type: "Error",
                    message_title: msgCatch,
                    message: msgCatchDetails,
                });
            } else if (typeNotificationError == "Toast") {
                $Helper.ThongBaoToast("error", msgCatch);
            }
            return {
                status: false,
                data: null,
                errorCode: 0,
                message: "Catch!",
            };
        } finally {
            this.isKhoaLuong[keyRequest] = undefined;
            $store.stopLoading();
        }
    };

    this.RequestGet = async ({
        ServicesBE = "Make",
        url = "",
        dataGet = null,
        msgSuccess = null,
        msgError = null,
        msgCatch = null,
    }) => {
        $store.startLoading();
        try {
            let rs = await $Core.Requests.Get({
                ServicesBE,
                url,
                dataGet,
            });
            if (
                (rs.hasOwnProperty("status") && rs.status) ||
                (rs.hasOwnProperty("State") && rs.State == "Success")
            ) {
                if (msgSuccess) {
                    $Helper.ThongBaoToast("success", msgSuccess);
                }
            } else {
                if (msgError) {
                    $Helper.ThongBaoToast(
                        "error",
                        msgError + " " + (rs.message || rs.Message || "")
                    );
                }
            }
            return rs;
        } catch (error) {
            console.log("🚀 ~ error:", error);
            if (msgCatch) {
                $Helper.ThongBaoToast("error", msgCatch);
            }
            return {
                status: false,
                data: null,
                errorCode: 0,
                message: msgCatch || "Catch!",
            };
        } finally {
            $store.stopLoading();
        }
    };

    this.StoreRequestPost = async ({
        keyRequest = "api",
        dispatch = "Common/RequestPost",
        ServicesBE = "Make",
        url = "",
        dataPost = null,
        msgSuccess = null,
        msgError = null,
        msgCatch = null,
    }) => {
        // Bắt buộc truyền thông báo
        if (!msgCatch || !msgError) {
            $Helper.ThongBaoToast(
                "error",
                "Chưa thể gửi request! Vui lòng kiểm tra lại"
            );
        }
        if (this.isKhoaLuong[keyRequest]) return;
        $store.startLoading();
        this.isKhoaLuong[keyRequest] = "pending...";
        try {
            let rs = await $store.dispatch(dispatch, {
                ServicesBE,
                url,
                dataPost,
            });

            if (
                (rs.hasOwnProperty("status") && rs.status) ||
                (rs.hasOwnProperty("State") && rs.State == "Success")
            ) {
                $Helper.ThongBaoToast("success", msgSuccess);
            } else {
                $Helper.ThongBaoToast(
                    "error",
                    msgError + (rs.message || rs.Message || "")
                );
            }
            return rs;
        } catch (error) {
            console.log("🚀 ~ error:", error);
            $Helper.ThongBaoToast("error", msgCatch);
            return {
                status: false,
                data: null,
                errorCode: 0,
                message: "Catch!",
            };
        } finally {
            this.isKhoaLuong[keyRequest] = undefined;
            $store.stopLoading();
        }
    };
    this.StoreRequestGet = async ({
        ServicesBE = "Make",
        dispatch = "Common/RequestGetData",
        url = "",
        dataGet = null,
        msgSuccess = null,
        msgError = null,
        msgCatch = null,
    }) => {
        $store.startLoading();
        try {
            let rs = await $store.dispatch(dispatch, {
                ServicesBE,
                url,
                dataGet,
            });
            if (
                (rs.hasOwnProperty("status") && rs.status) ||
                (rs.hasOwnProperty("State") && rs.State == "Success")
            ) {
                if (msgSuccess) {
                    $Helper.ThongBaoToast("success", msgSuccess);
                }
            } else {
                if (msgError) {
                    $Helper.ThongBaoToast(
                        "error",
                        msgError + " " + (rs.message || rs.Message || "")
                    );
                }
            }
            return rs;
        } catch (error) {
            console.log("🚀 ~ error:", error);
            if (msgCatch) {
                $Helper.ThongBaoToast("error", msgCatch);
            }
            return {
                status: false,
                data: null,
                errorCode: 0,
                message: "Catch!",
            };
        } finally {
            $store.stopLoading();
        }
    };

    this.CatchRequest = (ex) => {
        if (ex.StatusCode && ex.StatusCode == 400) {
            $Helper.ThongBaoPopup({
                type: "Error",
                message_title: "Dữ liệu gửi đi không hợp lệ!",
                message: `Vui lòng kiểm tra lại hoặc liên hệ kỹ thuật viên hoặc gọi điện đến số "1900.4751 - nhánh 2" để được hỗ trợ.`,
                statusCode: 400,
            });
        }
        if (ex.StatusCode && ex.StatusCode == 401) {
            $Helper.ThongBaoPopup({
                type: "Error",
                message_title: "Lỗi không thể xác thực tài khoản!",
                message: "Vui lòng đăng nhập lại để thực hiện.",
                statusCode: 401,
            });
        }
        if (ex.StatusCode && ex.StatusCode >= 500) {
            $Helper.ThongBaoPopup({
                type: "Error",
                message_title: "Lỗi kết nối đến máy chủ!",
                message: `Vui lòng liên hệ kỹ thuật viên hoặc gọi điện đến số "1900.4751 - nhánh 2" để được hỗ trợ.`,
                statusCode: ex.StatusCode,
            });
        }
    };

    this.Print = async (url_base, url, data, method = "POST") => {
        try {
            $store.startLoading();
            var a = await fetch($Helper.checkPath(url_base + url), {
                method: method,
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${$Core.Auth.Token}`,
                },
                body: JSON.stringify(data),
            });
            var b = await a.blob();
            var u = URL.createObjectURL(b);

            var o = window.open(u, "_blank");
            o.onload = function () {
                o.print();
            };
            return true;
        } catch (error) {
            console.log("🚀 ~ error:", error);
            return false;
        } finally {
            $store.stopLoading();
        }
    };

    this.Common = Devextreme;
}
